import { Dictionary } from "../../../utils/sys/Dictionary";

type ValueGetter = (t: any) => string | number;

export default abstract class KeyedValueSorter {
    protected static valueGetters: Dictionary<string, ValueGetter> = new Dictionary<string, ValueGetter>();

    public static createSorter<T>(sortKey?: string | null, direction: "desc" | "asc" = "desc"): (t1: T, t2: T) => number {
        if (sortKey == null || !this.valueGetters.hasKey(sortKey)) {
            return (_, __) => 0;
        }

        const valueGetter = this.valueGetters.get(sortKey) ?? ((_: T) => "");

        return (t1: T, t2: T) => {
            const v1 = valueGetter(t1);
            const v2 = valueGetter(t2);

            return typeof v1 === "number" && typeof v2 === "number" ?
                (direction === "desc" ? v1 - v2 : v2 - v1) :
                typeof v1 === "string" && typeof v2 === "string" ?
                (direction === "desc" ? v2.localeCompare(v1) : v1.localeCompare(v2)) : 0;
        };
    }
}
